// src/components/Flashcard.js
import React, { useState } from 'react';
import './Flashcard.css';

const Flashcard = ({ word, definition, example_sentence }) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div className={`flashcard ${flipped ? 'flipped' : ''}`} onClick={() => setFlipped(!flipped)}>
      <div className="front">
        {word}
      </div>
      <div className="back">
        <p className="definition">{definition}</p>
        {example_sentence && <p className="example"><i>Example: {example_sentence}</i></p>}
      </div>
    </div>
  );
};

export default Flashcard;